<template>
    <div class="" style="">
      <div class="topImgContent">
        <div class="topImgTitleContent">
          <div class="topImgTitle">政策解读</div>
          <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
        </div>
      </div>
      <div class="e-flex trp_searchWhite">
        <div class="trp_searchType e-flex">
            <el-select v-model="searchType" placeholder="请选择">
                <el-option :key="1" label="搜索标题" :value="1"> </el-option>
                <el-option :key="2" label="搜索正文" :value="2"> </el-option>
            </el-select>
            <img class="ic_sanjiao" src="@/assets/images/ic_sanjiao.png">
        </div>
        <div class="trp_searchName e-flex">
            <el-input v-model="searchName" placeholder="请输入内容"></el-input>
        </div>
        <div class="trp_searchBtn e-flex" @click="getList()">
            <img class="ic_search" src="@/assets/images/ic_search.png">
            <div>搜索</div>
        </div>
      </div>
      <div class="e-flex trp_centerContent">
        <div class="trp_centerLeft">
            <div class="trp_centerLeftTitle">发布时间</div>
            <div class="trp_centerLeftDateContent e-flex">
                <div class="trp_centerLeftDateBlock e-flex">
                    <el-date-picker v-model="startDate" type="date" placeholder="开始日期" prefix-icon="none" @change="startDateChange"></el-date-picker>
                    <img class="ic_date" src="@/assets/images/ic_date.png">
                </div>
                <div class="trp_centerLeftDateZhi">至</div>
                <div class="trp_centerLeftDateBlock e-flex">
                    <el-date-picker v-model="endDate" type="date" placeholder="结束日期" prefix-icon="none" @change="endDateChange"></el-date-picker>
                    <img class="ic_date" src="@/assets/images/ic_date.png">
                </div>
            </div>
            <div class="trp_centerLeftTitle">政策层级</div>
            <div class="trp_centerLeftListContent">
                <div v-for="(item, index) in policySearchList" :class="'trp_centerLeftListBlock ' + (index == policySearchIndex ? 'trp_centerLeftListBlockActive' : '')" @click="policySearch(item,index)">{{ item.name }}</div>
            </div>
            <div class="trp_centerLeftTitle">行业</div>
            <div class="trp_centerLeftListContent">
                <div v-for="(item, index) in industrySearchList" :class="'trp_centerLeftListBlock ' + (index == industrySearchIndex ? 'trp_centerLeftListBlockActive' : '')" @click="industrySearch(item,index)">{{ item.name }}</div>
            </div>
            <div class="trp_centerLeftTitle">适用领域</div>
            <div class="trp_centerLeftListContent">
                <div v-for="(item, index) in domainSearchList" :class="'trp_centerLeftListBlock ' + (index == domainSearchIndex ? 'trp_centerLeftListBlockActive' : '')" @click="domainSearch(item,index)">{{ item.name }}</div>
            </div>
            <div class="trp_centerLeftTitle">两区专项</div>
            <div class="trp_centerLeftListContent">
                <div v-for="(item, index) in projectSearchList" :class="'trp_centerLeftListBlock ' + (index == projectSearchIndex ? 'trp_centerLeftListBlockActive' : '')" @click="projectSearch(item,index)">{{ item.name }}</div>
            </div>
        </div>
        <div class="trp_centerRight">
            <div class="trp_rightList" v-for="(item, index) in dataList" @click="goDetail(item.id)">
                <div class="trp_rightListTitle e-line-1" v-html="item.title"></div>
                <div class="trp_rightListCommon e-line-2" v-html="item.content"></div>
                <div class="trp_rightUpdate">{{ '发布时间：' + item.publishDate }}</div>
            </div>
            <div class="noDataContent" v-if="dataList.length == 0">
              <img class="noDataImg" src="@/assets/images/noDataImg.png">
              <div class="noDataText">暂无内容</div>
            </div>
            <div class="e-flex trp_paginationContent">
                <el-pagination background layout="prev, pager, next, jumper" :page-size="10" :total="recordsTotal" @current-change="pageChange"></el-pagination>
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import '../../styles/twoRegionPolicy.css'
    export default {
      name: 'twoRegionPolicy',
      data () {
        return {
            searchType: 1,
            searchName: '',
            startDate: '',
            endDate: '',
            policySearchList: [{
                name: '不限',
                id: ''
            }],
            policySearchIndex: 0,
            industrySearchList: [{
                name: '不限',
                id: ''
            }],
            industrySearchIndex: 0,
            domainSearchList: [{
                name: '不限',
                id: ''
            }],
            domainSearchIndex: 0,
            projectSearchList: [{
                name: '不限',
                id: ''
            }],
            projectSearchIndex: 0,
            dataList: [],
            page: 1,
            recordsTotal: 0
        }
      },
      created() {
        this.getLevel()
        this.getBusiness()
        this.getZone()
        this.getArea()
        this.getList()
      },
      methods: {
        policySearch(item, index) {
            this.policySearchIndex = index
            this.getList()
        },
        industrySearch(item, index) {
            this.industrySearchIndex = index
            this.getList()
        },
        domainSearch(item, index) {
            this.domainSearchIndex = index
            this.getList()
        },
        projectSearch(item, index) {
            this.projectSearchIndex = index
            this.getList()
        },
        startDateChange(e) {
            this.startDate = !e ? '' : this.getDateStr(e)
            this.getList()
        },
        endDateChange(e) {
            this.endDate = !e ? '' : this.getDateStr(e)
            this.getList()
        },
        getDateStr(e) {
            // let date = new Date()
            let year = e.getFullYear()
            let month = (e.getMonth() + 1) < 10 ? '0' + (e.getMonth() + 1) : e.getMonth() + 1
            let day = e.getDate() < 10 ? '0' + e.getDate() : e.getDate()
            return year + '-' + month + '-' + day
        },
        pageChange(e) {
          this.page = e
          this.getList()
        },
        searchText() {
            this.dataList.forEach((item, index, array) => {
                item.title = item.title.replaceAll('<span style="color: #008CFF">','')
                item.title = item.title.replaceAll('</span>','')
                item.content = item.content.replaceAll('<span style="color: #008CFF">','')
                item.content = item.content.replaceAll('</span>','')
            })
            if (this.searchName == '') {
                return
            }
            this.dataList.forEach((item, index, array) => {
                if (this.searchType == 1) {
                    item.title = item.title.replaceAll(this.searchName,'<span style="color: #008CFF">' +this.searchName+ '</span>')
                } else if (this.searchType == 2) {
                    item.content = item.content.replaceAll(this.searchName,'<span style="color: #008CFF">' +this.searchName+ '</span>')
                }
            })
        },
        getLevel() {
            this.request({
                url: 'baseInfo/levelList?page=1&limit=99',
                method: 'get',
                data: {}
            }).then(res => {
                this.policySearchList = this.policySearchList.concat(res.data)
            })
        },
        getBusiness() {
            this.request({
                url: 'baseInfo/businessList?page=1&limit=99',
                method: 'get',
                data: {}
            }).then(res => {
                this.industrySearchList = this.industrySearchList.concat(res.data)
            })
        },
        getZone() {
            this.request({
                url: 'baseInfo/zoneList?page=1&limit=99',
                method: 'get',
                data: {}
            }).then(res => {
                this.domainSearchList = this.domainSearchList.concat(res.data)
            })
        },
        getArea() {
            this.request({
                url: 'baseInfo/areaList?page=1&limit=99',
                method: 'get',
                data: {}
            }).then(res => {
                this.projectSearchList = this.projectSearchList.concat(res.data)
            })
        },
        getList() {
            let param = {
                page: this.page,
                limit: 10,
                type: 1,
                levelId: this.policySearchList[this.policySearchIndex].id,
                zoneId: this.domainSearchList[this.domainSearchIndex].id,
                areaId: this.projectSearchList[this.projectSearchIndex].id,
                businessId: this.industrySearchList[this.industrySearchIndex].id,
                startDate: this.startDate,
                endDate: this.endDate
            }
            if (this.searchType == 1) {
                param.title = this.searchName
            } else {
                param.content = this.searchName
            }
            this.request({
                url: 'policy/list',
                method: 'POST',
                data: param
            }).then(res => {
                res.data.forEach((item, index, array) => {
                    item.content = item.content.replace(/<\/?.+?\/?>/g,'')
                })
                this.dataList = res.data
                this.recordsTotal = res.recordsTotal
                if (this.searchName) {
                    this.searchText()
                }
            })
        },
        goDetail(id) {
            this.$router.push({ path: '/twoRegionPolicy/policyInterpretationDetail', query: {id: id,searchType: this.searchType,searchName: this.searchName}})
        }
      }
    }
  </script>

  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/twoRegionPolicy/policyInterpretation.vue